import { gql } from '@/shared/graphql/generated/lp';

gql(/* GraphQL */ `
  fragment BoostBalanceChange on BoostLiquidityBalanceChange {
    amount
    amountUsd
    type
    event: eventByEventId {
      block
      indexInBlock
      timestamp
    }
    pool: boostPoolByBoostPoolId {
      asset
      feeTierPips
    }
    boost: boostByBoostId {
      depositChannel: depositChannelByDepositChannelId {
        chain
        channelId
        issuedBlockId
      }
    }
  }
`);

export const getTotalBoostFeesForPool = gql(/* GraphQL */ `
  query GetTotalBoostFeesForPool($startingTimestamp: Datetime!) {
    allBoosts(filter: { settledAtTimestamp: { greaterThanOrEqualTo: $startingTimestamp } }) {
      aggregates {
        sum {
          feeUsd
        }
      }
    }
  }
`);
